import React, { useState, useEffect } from 'react'
import { Bar, Pie, Line } from 'react-chartjs-2'
import Headline from '../atoms/Headline'

import useMediaQuery from '../../hooks/useMediaQuery'
import SbEditable from 'storyblok-react'

const ChartBlock = ({ block }) => {
  const [chart, setChart] = useState(null)

  // TODO: define colors
  // TODO: define charts width & height

  let isMobile = useMediaQuery(`(max-width: 575.98px)`)

  let colors = []

  if (block?.type !== 'pie' && block.datasets?.length <= 1) {
    colors = ['#76B82A']
  } else {
    colors = [
      // Alte dunkle Farben
      // '#010100',
      // '#1E2F0B',
      // '#3B5D15',
      // '#598A20',

      '#365413',
      '#466D19',
      '#56861F',
      '#669F24',
      '#76B82A',
      '#8BD239',
      '#9ED95A',
      '#B2E17B',
      '#C5E99D',
      '#CFECAD',

      // '#ffc5b1',
      // '#ff9a77',
      // '#ff6e3d',
      // '#cc5831',
      // '#994225',

      // '#c8e3aa',
      // '#9fcd6a',
      // '#76B82A',
      // '#5e9322',
      // '#476e19',

      '#cccccc',
      '#a6a6a6',
      '#808080',
      '#666666',
      '#4d4d4d',
    ]
  }

  const CustomTooltipLabel = (tooltipItem) => {
    let labeltext = 0
    labeltext = `${tooltipItem.label}: ${tooltipItem.formattedValue} ${
      block.tooltip_unit?.length > 0 ? block.tooltip_unit : ''
    }`
    return labeltext
  }

  const options = {
    maintainAspectRatio: block?.type === 'pie' ? false : true,
    plugins: {
      legend: {
        position:
          block.legend_position?.length > 0 ? block.legend_position : 'right',
        display: !block.hide_legend,
      },
      tooltip: {
        callbacks: {
          label: CustomTooltipLabel,
        },
      },
    },
    scales: {
      y: {
        grid: {
          display: block?.type === 'pie' ? false : true,
        },
        display: block?.type === 'pie' ? false : true,
        title: {
          display: true,
          text: block.y_axis_label,
        },
        beginAtZero: block.start_at_zero,
        stacked: block.stacked,
      },
      x: {
        stacked: block.stacked,
        grid: {
          display: block?.type === 'pie' ? false : true,
        },
        display: block?.type === 'pie' ? false : true,
      },
      //responsive: false,
    },
  }

  const composeChart = () => {
    const allLabels = block?.labels?.split(',')
    const allDataset = block?.datasets?.map((set, idx) => {
      return {
        label: set?.dataset_title,
        data: set?.values?.split(','),
        backgroundColor: block?.distinct_colors ? colors : colors[idx],
        borderColor: block.stacked
          ? '#fff'
          : block.type === 'pie' || block.stacked
          ? '#fff'
          : block?.distinct_colors
          ? colors
          : colors[idx],
        borderWidth:
          block.type === 'pie' || block.stacked
            ? 1
            : block.type === 'line'
            ? '2'
            : '',
        tension: block?.smoothness,
        fill: block?.fill,
      }
    })
    return {
      labels: allLabels,
      datasets: allDataset,
    }
  }

  useEffect(() => {
    setChart(composeChart())

    return () => {
      setChart(null)
    }
  }, [block])

  if (!chart) return <></>

  return (
    <SbEditable content={block}>
      <section
        className={`chart-block ${block.space_top ? block.space_top : ''} ${
          block.space_bottom ? block.space_bottom : ''
        }`}
      >
        <div className="chart-block-container">
          <Headline
            kicker={block.kicker}
            headline={block.headline}
            subheadline={block.subheadline}
          />
          <div className={`chart-block-chart chart-block-chart-${block?.type}`}>
            {block?.type === 'pie' ? (
              <Pie data={chart} width={100} height={'50vh'} options={options} />
            ) : block?.type === 'bar' ? (
              <Bar
                data={chart}
                width={100}
                height={isMobile ? 75 : 50}
                options={options}
              />
            ) : block?.type === 'line' ? (
              <Line
                data={chart}
                width={100}
                height={isMobile ? 75 : 50}
                options={options}
              />
            ) : null}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ChartBlock
